export default __webpack_public_path__ + "static/health_banner_gif-4e43ea8201cd219f7efbae7a6d30ed09.gif";